import {getCurrentTenant} from '@pluto-tv/lib-command-center-ts';
type Variant = 'dark' | 'light';
interface ThemeConfig {
  theme: string;
  variant: Variant;
}
export function getThemeConfig(): ThemeConfig {
  const theme = getCurrentTenant() || 'plutotv';
  const variant: Variant = theme === 'plutotv' ? 'dark' : 'light';
  return {theme, variant};
}
